import { SxProps, Theme } from '@mui/material';

const dialogTitle: SxProps<Theme> = {
  pb: '8px'
};

const subtitleText: SxProps<Theme> = {
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 500,
  whiteSpace: 'pre-line'
};

const getDialogContentSx = (hasTitle: boolean): SxProps<Theme> => ({
  pt: hasTitle ? 0 : '24px'
});

const submitButton: SxProps<Theme> = {
  width: '100%'
};

const getCancelButtonSx = (isLoading: boolean): SxProps<Theme> => ({
  width: '100%',
  opacity: isLoading ? 0 : 1
});

const dialog: SxProps<Theme> = {
  zIndex: 1500
};

const getDialogPaperSx = (width?: string): SxProps<Theme> => ({
  maxWidth: width ?? '380px'
});

export const modalV2Sx = {
  dialogTitle,
  subtitleText,
  getDialogContentSx,
  submitButton,
  getCancelButtonSx,
  dialog,
  getDialogPaperSx
};
